// src/firebase.js
import { initializeApp } from "firebase/app";
import {
  getFirestore, collection, query, where, orderBy, onSnapshot,
  addDoc, updateDoc, deleteDoc, doc, serverTimestamp, increment,
  enableIndexedDbPersistence
} from "firebase/firestore";
import { getAuth, signInAnonymously, onAuthStateChanged } from "firebase/auth";

// Usa .env.local en local y variables de entorno en producción.
// Si alguna faltara, puedes dejar los literales como fallback.
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FB_API_KEY,               // ej.: "AIzaSy……"
  authDomain: process.env.REACT_APP_FB_AUTH_DOMAIN,       // ej.: "xxx.firebaseapp.com"
  projectId: process.env.REACT_APP_FB_PROJECT_ID,         // ej.: "xxx"
  storageBucket: process.env.REACT_APP_FB_STORAGE_BUCKET, // ej.: "xxx.appspot.com"
  messagingSenderId: process.env.REACT_APP_FB_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FB_APP_ID,
};

export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);

// Persistencia offline (opcional)
enableIndexedDbPersistence(db).catch(() => {});

export async function ensureAuth() {
  return new Promise((resolve) => {
    onAuthStateChanged(auth, async (user) => {
      if (!user) await signInAnonymously(auth);
      resolve(auth.currentUser);
    });
  });
}

export const COL_ITEMS = "items";
export const orgId = "default";

/**
 * Suscripción en tiempo real
 * IMPORTANTE: Los datos primero y el id de Firestore al final.
 * Así evitamos que un campo 'id' dentro del documento sobrescriba d.id.
 */
export function listenItems(cb) {
  const q = query(
    collection(db, COL_ITEMS),
    where("org", "==", orgId),
    orderBy("createdAt", "desc")
  );
  return onSnapshot(q, (snap) => {
    const arr = [];
    snap.forEach((d) => {
      arr.push({ ...d.data(), id: d.id });
    });
    cb(arr);
  });
}

export async function addItemDoc(data) {
  // Asegúrate de que todos los docs nuevos llevan org para que casen con las reglas.
  return addDoc(collection(db, COL_ITEMS), {
    ...data,
    org: orgId,
    createdAt: serverTimestamp(),
  });
}

export async function updateItemDoc(id, data) {
  return updateDoc(doc(db, COL_ITEMS, id), data);
}

export async function deleteItemDoc(id) {
  return deleteDoc(doc(db, COL_ITEMS, id));
}

export async function incrementQty(id, by) {
  return updateDoc(doc(db, COL_ITEMS, id), { cantidad: increment(by) });
}
